import { Component, Inject, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Media } from '@digilize/shared/definitions/src';

@Component({
  selector: 'lsl-text-dialog',
  templateUrl: './text-dialog.component.html',
  styleUrls: ['./text-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class TextDialogComponent implements OnInit {
  constructor(
    public dialogRef: MatDialogRef<TextDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: TextDialogComponentData
  ) {}

  ngOnInit(): void {
    console.log(this.data.html);
  }
  close() {
    this.dialogRef.close();
  }
}

export interface TextDialogComponentData {
  html: string;
  audio: Media;
}
